var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBluecheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -4.28348,
    y: -3.40067,
    width: 23.5592,
    height: 23.5592
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.14px)",
      clipPath: "url(#bgblur_0_13720_64024_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 4.28348
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.882812,
    width: 14.9922,
    height: 14.9922,
    rx: 7.49609,
    fill: "#5858ED"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1568 5.82991C11.331 6.00416 11.331 6.28667 11.1568 6.46093L6.69484 10.9229C6.5206 11.0971 6.23807 11.0971 6.06382 10.9229L3.83284 8.69191C3.65859 8.51767 3.65859 8.23513 3.83284 8.06089C4.00709 7.88665 4.2896 7.88665 4.46386 8.06089L6.37933 9.97637L10.5258 5.82991C10.7 5.65566 10.9826 5.65566 11.1568 5.82991Z",
    fill: "#E8EBEE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_13720_64024_clip_path",
    transform: "translate(4.28348 3.40067)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.882812,
    width: 14.9922,
    height: 14.9922,
    rx: 7.49609
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluecheck);
export default __webpack_public_path__ + "static/media/bluecheck.778ef683d6bd324e0ac9dfcbc893bbac.svg";
export { ForwardRef as ReactComponent };